import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const storeShiftToDo = async (
  payload: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/log/set_to_do`, {
      token: idToken,
      payload,
    });
    return res.data;
  } else {
    throw new Error('Error setting to do');
  }
};

export const deactivateShiftToDo = async (
  payload: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(
      `/log/deactivate_shift_to_do`,
      {
        token: idToken,
        payload,
      }
    );
    return res.data;
  } else {
    throw new Error('Error setting to do');
  }
};

export const updateLogEntryTimes = async (
  payload: any,
  timezone: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/log/update_times`, {
      token: idToken,
      payload,
      timezone,
    });
    return res.data;
  } else {
    throw new Error('Error creating site');
  }
};

export const findLogEntriesByDate = async (
  dateKey: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();

  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/log/findByDate`, {
      token: idToken,
      dateKey,
    });
    return res.data;
  } else {
    throw new Error('Error fetching session');
  }
};

export const updateLogEntriesAndVisitors = async () => {
  try {
    const { tokens } = await fetchAuthSession();

    if (tokens) {
      const idToken = tokens.idToken?.toString();
      const res = await api.post('/log/update_log', {
        //also updates visitors
        token: idToken,
      });
      return res.data;
    } else {
      throw new Error('NO SESSION');
    }
  } catch (err) {
    console.log(err);
    throw new Error('User Not found');
  }
};

export const invalidateEntry = async (
  payload: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/log/invalidate_entry`, {
      token: idToken,
      payload,
    });
    return res.data;
  } else {
    throw new Error('Error creating site');
  }
};

export const createLogEntry = async (
  type: string,
  description: string,
  time: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/log/createLogEntry`, {
      token: idToken,
      type,
      description,
      time,
    });
    return res.data;
  } else {
    throw new Error('Error creating site');
  }
};
